import React, { useRef, useEffect } from "react";
import PropTypes from "prop-types";
import styled from "styled-components";

// Context
import { useFormSelectDialog } from "core/FormSelectDialog/context/useFormSelectDialog";

// components
import DisplayText from "./DisplayText";

// styles
import { focusStyles } from "core/colors";
import { convertPxToRem } from "frontend/components/helpers";

export const ControlStyled = styled.button`
    display: ${({ $controlDisplay }) => $controlDisplay};
    align-items: center;
    box-sizing: border-box;
    border: none;
    border-radius: 0px;
    background-color: transparent;
    cursor: pointer;
    padding: 0rem;
    margin: 0rem;
    height: inherit;
    width: 100%;

    font-size: ${convertPxToRem(15)};
    ${focusStyles}

    &:disabled {
        cursor: not-allowed;
    }
`;

export const ContentWrapperStyled = styled.div`
    width: 100%;
    min-width: 0;
    display: flex;
    gap: ${convertPxToRem(15)};
    justify-content: ${({ $controlJustifyContent }) => $controlJustifyContent};
`;

const Control = ({ children }) => {
    const {
        id,
        label,
        hasOpenedBefore,
        isOpen,
        setIsOpen,
        isDisabled,
        controlDisplay,
        controlJustifyContent,
    } = useFormSelectDialog();

    const controlButtonRef = useRef();

    // methods
    const onClick = e => {
        if (!isDisabled) {
            e.stopPropagation();
            setIsOpen(!isOpen);
        }
    };

    // side effects
    useEffect(() => {
        if (hasOpenedBefore && !isOpen) {
            controlButtonRef.current.focus();
        }
    }, [hasOpenedBefore, isOpen]);

    // render
    return (
        <ControlStyled
            id={`${id}-dropdown-button`}
            aria-label={label}
            type="button"
            onClick={onClick}
            ref={controlButtonRef}
            disabled={isDisabled}
            isOpen={isOpen}
            $controlDisplay={controlDisplay}
        >
            <ContentWrapperStyled
                $controlJustifyContent={controlJustifyContent}
            >
                <DisplayText />
                {children}
            </ContentWrapperStyled>
        </ControlStyled>
    );
};

export default Control;

// prop-types
Control.propTypes = {
    children: PropTypes.any,
};
